import styled from 'styled-components';

export const AccordionContainer = styled.div`
  position: relative;
  margin-bottom: 3rem;
`;
